
import { defineComponent } from "vue";
import "highlight.js/styles/github-gist.css";
import ThemeToggle from "@/components/ThemeToggle.vue";
import { routes } from "@/router/index";

export default defineComponent({
  name: "App",
  components: {
    ThemeToggle,
  },
  data() {
    return {
      routes,
      baseUrl: process.env.BASE_URL,
    };
  },
});
